import React, { useEffect, useState } from "react";
import { Page } from "./styles";
import moment from "moment";
import "moment/locale/pt-br";
import { ILog, Log } from "../Log";
import { message } from "antd";
import { api } from "../../services/api";
import { Load } from "../Load";
import { Empty } from "../Empty";
import { useAuth } from "../../hooks/auth";
import { useNavigate } from "react-router-dom";
moment.locale("pt-br");

const LastLogs = () => {
  const { user } = useAuth()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true);
  const [logs, setLogs] = useState<ILog[]>([]);
  function fetchData() {
    setLoading(true);
    const route = user.type === 'USER' ? 'logs' : 'clients/logs' 
    api
      .get<[ILog[], number]>(route, {
        params: {
          size: 10,
          page: 0,
        },
      })
      .then((response) => {
        const [data, _] = response.data;
        setLogs(data);
      })
      .catch((e) => {
        message.error(e.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }
  function handleMoreClick() {
    navigate('/logs')
  }
  useEffect(fetchData,[])
  return (
    <Page>
      <h1>Últimos logs:</h1>
      <div className="content">
        {
          loading
          ? <Load />
          : logs.length
          ? logs.map((log)=> <Log {...log} />)
          : (<Empty />)
        }
       
      </div>
      <p onClick={handleMoreClick}>Ver mais</p>
    </Page>
  );
};
export { LastLogs };
